//营销管理
import http from '../jslibs/axios/http';

// 反馈列表
export const getFeedbackList = data => http.get('/cms/Feedback', data);
//反馈详情
export const getFeedbackDetail = data => http.get('/cms/Feedback/' + data.uuid);


// 积分列表
export const getConfigList = data => http.get('/cms/Config', data);
// 积分详情
export const getConfigDetail = data => http.get('/cms/Config/' + data.key, data);
//修改积分详情
export const updateConfigList = data => http.put('/cms/Config/' + data.key, data);


// 积分下发列表
export const getSendScoreList = data => http.get('/cms/SendScore', data);
// 新增积分下发
export const addSendScore = data => http.post('/cms/SendScore', data);

// 消息列表
export const getMsgPushList = data => http.get('/cms/MsgPush', data);
// 新增消息
export const addMsgPush = data => http.post('/cms/MsgPush', data);
//删除
export const deleteMsgPush = data => http.delete('/cms/MsgPush/' + data.uuid, data);

export const putMsgPush = data => http.put('/cms/MsgPush/' + data.uuid, data);